import { styled } from "@mui/material";

import {
  Actions,
  ConfirmButton,
  Container,
  SquareButton,
  ValueContainer as StyledValueContainer,
  BaseTextField as TextField,
  Value,
} from "./integrated-text-field.sx";

export { Actions, ConfirmButton, Container, SquareButton, TextField, Value };

export const RangeInputs = styled("div")(({ theme }) => ({
  display: "flex",
  flex: 1,
  gap: theme.spacing(1),
}));

export const ValueContainer = styled(StyledValueContainer)(({ theme }) => ({
  gap: theme.spacing(1),
}));
